import { getTagConfig } from 'mod/product/utils';
import type { IStyleConfig } from 'base/interfacesV2/feature';
import type { ICartItemProductTag } from '@base/cart/interface';

export const getCartItemTagConfig = (
    productTags: ICartItemProductTag[]
): IStyleConfig | undefined => {
    // 找到设置的tag配置
    let tagConfig;

    productTags?.find((tag) => {
        const _tagConfig = getTagConfig(tag.tag.toLocaleLowerCase() as any, 'picTag')
        if (!!_tagConfig) {
            tagConfig = _tagConfig;
        }
        return !!_tagConfig;
    })

    return tagConfig;
}